/** Mirrors only PDF.js 5.7.284's command cursor, not the command implementation.
 * Remote replacement advances an epoch so native closures cannot resurrect old ink.
 * PDF.js still executes every actual undo/redo command and owns the 128-entry limit.
 */
export class PdfInkHistory{
 epoch=0;
 private entries:Array<{epoch:number;type:number}>=[];
 private position=-1;
 get canUndo(){return this.entries[this.position]?.epoch===this.epoch;}
 get canRedo(){return this.entries[this.position+1]?.epoch===this.epoch;}
 canOverwrite(type=NaN){return this.canUndo&&this.entries[this.position]?.type===type;}
 add(type=NaN,overwrite=false){
  const entry={epoch:this.epoch,type};
  if(this.position===-1){this.entries=[entry];this.position=0;return;}
  if(overwrite&&this.entries[this.position].type===type){this.entries[this.position]=entry;return;}
  const next=this.position+1;
  if(next===128)this.entries.splice(0,1);else{this.position=next;this.entries.splice(next);}
  this.entries.push(entry);
 }
 undo(){if(this.canUndo)this.position--;}
 redo(){if(this.canRedo)this.position++;}
 clean(type:number){
  if(this.position===-1)return;
  for(let i=this.position;i>=0;i--)if(this.entries[i].type!==type){this.entries.splice(i+1,this.position-i);this.position=i;return;}
  this.entries=[];this.position=-1;
 }
 invalidate(){this.epoch++;}
}
